import styles from './PriceDynamicsInfo.css';
import { UIText1 } from '@cian/ui-kit';
import { FC, ReactElement } from 'react';

interface IPriceDynamicsInfo {
  differencePrice: {
    text: string;
    icon: ReactElement<any> | null;
    diffPercent: string | null;
  };
  periodText: string;
  averageContent: string | ReactElement<any>;
  priceChangeContent: string | ReactElement<any>;
  isRoomsCountAll: boolean;
}

export const PriceDynamicsInfo: FC<IPriceDynamicsInfo> = ({
  averageContent,
  periodText,
  isRoomsCountAll,
  priceChangeContent,
}) => {
  return (
    <div className={styles['container']}>
      <div className={styles['item']}>
        <UIText1 color="gray60_100">Средняя цена за {isRoomsCountAll ? 'м²' : 'квартиру'}</UIText1>
        <div className={styles['item_info']}>{averageContent}</div>
      </div>
      <div className={styles['item']}>
        <div className={styles['subtitle']}>
          <UIText1 color="gray60_100">Изменение цены за {periodText}</UIText1>
        </div>
        <div className={styles['item_info']}>{priceChangeContent}</div>
      </div>
    </div>
  );
};
